export const NOTIFICATION_MESSAGES = {
  // Login/Auth
  loginSuccess: 'Welcome back ',
  loginError: 'Could not login, please try again.',
  unauthorized: 'You are not authorized to access this page.',
  unauthenticated: 'Please log in to access this page.',
  sessionExpired: 'Your session has expired, please log in again.',
  logoutSuccess: 'Logged out successfully.',
  logoutError: 'Could not logout, please try again.',

  // Operations
  success: {
    update: 'Company updated successfully.',
    create: 'Company was successfully added to the Database.',
    delete: 'Company was successfully deleted.',
    createProduct: 'Product was successfully added to the company.',
    deleteProduct: 'Product was successfully deleted.',
    addSubprocessor: 'Subprocessor was successfully added to the company.',
    editSubprocessor: 'Subprocessor was successfully updated.',
    removeSubprocessor: 'Subprocessor was successfully removed.',
    addSubprocessorNote: 'Note added successfully.',
    editSubprocessorNote: 'Note updated successfully.',
    removeSubprocessorNote: 'Note removed successfully.',
    addCompanyNote: 'Note added successfully.',
    editCompanyNote: 'Note updated successfully.',
    deleteCompanyNote: 'Note removed successfully.',
    deleteCompanyFile: 'Document was successfully deleted.',
    createAiAssessment: 'Great! Our AI is has started to research this company.',
    getSuggestions: 'Company suggestions were successfully retrieved.',
    linkCopied: 'Link copied to clipboard!',
    pathCopied: 'Path copied to clipboard!',
    addressCopied: 'Address copied to clipboard!',
    navigated: 'Navigated to updated page',
    refreshCompanyData: 'Company data refreshed successfully',
    refreshProductData: 'Product data refreshed successfully',
    refreshAiAssessment: 'AI assessment refreshed successfully',
    refreshData: 'Data refreshed successfully',
    createSubtraceGrant: 'Grant created and sent successfully.',
    creationRequestNoteSaved: 'Note saved successfully.',
    creationRequestDenied: 'Request has been denied.',
    creationRequestApproved: 'Creation request approved.',
    triggerSubprocessorList: 'Subprocessor list fetch started. This may take a few minutes.',
    fetchCompanyDocuments: (queued) =>
      `Started ${queued} document fetch ${queued === 1 ? 'job' : 'jobs'}.`,
    fetchCompanyDocumentsAlreadyPresent: 'This company already has the default documents.',
  },
  error: {
    unknown: 'Something went wrong, please try again later.',
    update: 'Could not update company. Please try again later.',
    create: 'Could not create company. Please try again later.',
    createCompanyMissingId: 'Created company is missing an ID. Please try again.',
    delete: 'Could not delete company. Please try again later.',
    createProduct: 'Could not create product. Please try again later.',
    deleteProduct: 'Could not delete product. Please try again later.',
    addSubprocessor: 'Could not add subprocessor. Please try again later.',
    subprocessorLinkMissingCompanyId: 'Cannot link CODB company. Created company is missing id.',
    editSubprocessor: 'Could not update subprocessor. Please try again later.',
    removeSubprocessor: 'Could not remove subprocessor. Please try again later.',
    addSubprocessorNote: 'Could not add note. Please try again later.',
    editSubprocessorNote: 'Could not update note. Please try again later.',
    removeSubprocessorNote: 'Could not remove note. Please try again later.',
    addCompanyNote: 'Could not add note. Please try again later.',
    editCompanyNote: 'Could not update note. Please try again later.',
    deleteCompanyNote: 'Could not remove note. Please try again later.',
    deleteCompanyFile: 'Could not delete document. Please try again later.',
    getCompanyFileLink: 'Could not download document. Please try again later.',
    getSuggestions: 'Could not get company suggestions. Please try again later.',
    getCompany: 'Could not get company. Please try again later.',
    getProduct: 'Could not get product. Please try again later.',
    copyLink: 'Failed to copy link to clipboard',
    copyPath: 'Failed to copy path to clipboard',
    copyAddress: 'Failed to copy address to clipboard',
    refreshData: 'Had issues refreshing the data',
    clearCache: 'Could not clear cache. Please try again later.',
    createSubtraceGrant: 'Could not create grant. Please try again later.',
    creationRequestNoteError: 'Could not save the note. Please try again.',
    creationRequestDenyError: 'Could not deny the request. Please try again.',
    creationRequestApproveError: 'Failed to approve creation request. Please try again.',
    creationRequestLoadError: 'Had issues loading creation requests, please try again later.',
    creationRequestApproveMissingCompanyId:
      'Cannot approve request. Created company is missing id.',
    triggerSubprocessorList: 'Could not trigger subprocessor list. Please try again later.',
    fetchCompanyDocuments: 'Could not fetch documents. Please try again later.',
    fetchCompanyDocumentsNotFound: 'Company not found.',
    subprocessorFileTooLarge: (limit) => `File exceeds the ${limit}MB limit.`,
    subprocessorFileType: 'Unsupported file type. Allowed: PDF, XLSX, TXT, CSV.',
    permissionDenied: "You don't have permission to do this.",
  },
}
